import React from 'react';
import { LayoutCard } from './list-user-products.styles';
import { getQueryError } from '@shared/lib/utils/get-query-error/get-query-error';
import { ListUserProductsProps } from './types';
import { useUserProductsListSharedQuery } from '@entities/product/libs/hooks/use-user-products-list-shared-query/use-user-products-list-shared-query';
import { PaginationLayout } from '@shared/ui/pagination-layout/pagination-layout';
import { PAGINATION_COUNTS_ON_PAGE_THREE_COLUMNS } from '@shared/ui/pagination/constants';
import { CardProductPreview } from '@entities/product/ui/card-product-preview/card-product-preview';
import { NetworkStateNew } from '@shared/ui/network-state-new/network-state-new';
import { usePrefetchProduct } from '@entities/product/api/product-api';
import { usePrefetchOrder } from '@entities/order/api/order-api';
import { useCurrentUserSelector } from '@entities/current-user/model/selectors';
import { listOrdersInProductParameters } from '@shared/lib/utils/list-orders-in-product-parameters/list-orders-in-product-parameters';

export const ListUserProducts: React.FC<ListUserProductsProps> = ({
    userProductsListParameters,
    setUserProductsListParameters,
}) => {
    const user = useCurrentUserSelector();
    const [, getUserProductsResult] = useUserProductsListSharedQuery(userProductsListParameters);
    const errorProducts = getQueryError(getUserProductsResult);
    const hasData = Boolean(getUserProductsResult.data?.total);
    const isLoading =
        getUserProductsResult.isFetching || getUserProductsResult.isLoading || getUserProductsResult.isUninitialized;

    const prefetchProduct = usePrefetchProduct('productShortInfo', { ifOlderThan: 300 });
    const prefetchOrder = usePrefetchOrder('ordersList', { ifOlderThan: 300 });

    const handlePrefetch = (productId: number) => () => {
        prefetchProduct(productId);
        prefetchOrder(
            listOrdersInProductParameters({
                productId,
                user,
            })
        );
    };

    return (
        <PaginationLayout
            listLength={getUserProductsResult.data?.total || 0}
            customCountsOnPage={PAGINATION_COUNTS_ON_PAGE_THREE_COLUMNS}
            isLoading={isLoading}
            parameters={userProductsListParameters}
            setParameters={setUserProductsListParameters}>
            <LayoutCard isCenter={!hasData}>
                <NetworkStateNew
                    isLoading={isLoading}
                    isInitialized={Boolean(getUserProductsResult.data)}
                    isError={Boolean(errorProducts)}
                    isFiltered={Boolean(getUserProductsResult.data?.search)}
                    hasData={hasData}
                    errorProps={{
                        title: 'Ошибка загрузки продуктов',
                        description: errorProducts?.message,
                    }}
                    emptyProps={{
                        title: 'Продукты отсутствуют',
                    }}
                    emptyFilteredProps={{
                        title: 'Продукты не найдены',
                    }}>
                    {getUserProductsResult.data?.items.map((product) => (
                        <CardProductPreview
                            key={product.id}
                            product={product}
                            onMouseDownPrefetch={handlePrefetch(product.id)}
                        />
                    ))}
                </NetworkStateNew>
            </LayoutCard>
        </PaginationLayout>
    );
};
